import script from "./BaseFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseFooter.vue?vue&type=script&setup=true&lang=js"

import "./BaseFooter.vue?vue&type=style&index=0&id=889ee116&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-889ee116"]])

export default __exports__